import _ from 'lodash';

export function isValidProgram(program) {
  return program?.id && program?.attributes?.provider?.id;
}

export function handleDeselectedProgram(feeScheduleContext, index) {
  const {
    feeScheduleProgramId, removeSelectedFieldsExceptIndex, setFeeScheduleProgramId,
  } = feeScheduleContext;
  if (!_.isNull(feeScheduleProgramId)) {
    removeSelectedFieldsExceptIndex(index);
    setFeeScheduleProgramId(null);
  }
}

export function handleSelectedProgram(program, feeScheduleContext, index) {
  const {
    feeScheduleProgramId, removeSelectedFieldsExceptIndex, setFeeScheduleProgramId,
  } = feeScheduleContext;
  const feeScheduleProgram = _.get(program, 'relationships.fee_schedule_program.data', {});
  if (feeScheduleProgram?.authorization_required && _.isNull(feeScheduleProgramId)) {
    removeSelectedFieldsExceptIndex(index);
    setFeeScheduleProgramId(feeScheduleProgram.id);
  }
}

export function handleDeselectedGroup(selectedFields, index, programContext) {
  const { selectedPrograms, dispatchRemoveProgram, onDeselect } = programContext;
  const programId = selectedFields[index]?.group?.value?.programs?.[0]?.id;
  if (programId && selectedPrograms.some((p) => p.id === programId)) dispatchRemoveProgram({ id: programId });
  onDeselect(index);
}

function toProgramEntry(program) {
  return {
    id: program?.id,
    name: program?.name,
    providerId: program?.attributes?.provider?.id,
  };
}

export function syncSelectedPrograms(selectedFields, dispatchRemoveAllPrograms, dispatchAddProgram, onSelect) {
  dispatchRemoveAllPrograms();
  selectedFields.forEach((field) => {
    const program = field?.program?.value;
    if (isValidProgram(program)) {
      dispatchAddProgram(toProgramEntry(program));
    }
  });
  onSelect();
}
